import { extractWorkspaceGroup, extractWorkspaceName, getBudgetAreaFromManagementGroup, getDataPlaneFormattedPath, getExperimentationGroupIdFromPath, getExperimentationGroupLabel, getExperimentationPathFromId, getManagementGroupLevels, getRootExperimentationGroup, getTenantFromManagementGroup, isClassicWorkspaceById, isClassicWorkspaceByName, isManagementGroupNameValid, isMsftWorkspaceById, isRootManagementGroup, isTestMsftWorkspaceById, splitManagementGroupPath } from "./ManagementGroup.utils.js";
export {
  extractWorkspaceGroup,
  extractWorkspaceName,
  getBudgetAreaFromManagementGroup,
  getDataPlaneFormattedPath,
  getExperimentationGroupIdFromPath,
  getExperimentationGroupLabel,
  getExperimentationPathFromId,
  getManagementGroupLevels,
  getRootExperimentationGroup,
  getTenantFromManagementGroup,
  isClassicWorkspaceById,
  isClassicWorkspaceByName,
  isManagementGroupNameValid,
  isMsftWorkspaceById,
  isRootManagementGroup,
  isTestMsftWorkspaceById,
  splitManagementGroupPath
};
//# sourceMappingURL=index.js.map
